var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultiselectTag',{attrs:{"multiple":false,"label":_vm.t('workflowengine', 'Select a tag')},on:{"input":_vm.update},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }